import React from 'react';
import PropTypes from 'prop-types';

import JobListing from '../../../components/JobV3/Elements/JobListing/JobListing';
import { ATTRIBUTION_MODE_CHERRYPICK } from '../../../contexts/AbstractContext';
import { JobContextProvider } from '../../../contexts/JobContext';
import SeeAllButton from './SeeAllButton';
import SectionHeader from './SectionHeader';

const JobResults = ({
    session,
    results: {
        results: jobResults,
        total,
        // These need to be present for algolia tracking to work
        queryID,
        indexName,
    } = {},
    isSingleSearch,
    url,
}) => {
    if (!total) return null;

    return (
        <JobContextProvider
            content={jobResults}
            session={session}
            attributionMode={ATTRIBUTION_MODE_CHERRYPICK}
            algoliaQueryId={queryID}
            algoliaIndexName={indexName}
        >
            <SectionHeader>JOBS IN YOUR LOCATION ({total})</SectionHeader>
            {(jobResults || []).map((j, pos) => (
                <JobListing
                    key={j.hash}
                    {...j}
                    showExpired={false}
                    algoliaTracking={{
                        positionInListing: pos + 1, // algolia is indexed from 1, not 0
                        queryID,
                        indexName,
                    }}
                />
            ))}
            <SeeAllButton
                text={`See all ${total} Jobs`}
                type="job"
                url={url}
                isSingleSearch={isSingleSearch}
            />
        </JobContextProvider>
    );
};

export default JobResults;

const ReactionBarPropType = PropTypes.shape({
    active: PropTypes.bool,
    enabled: PropTypes.bool,
    icon: PropTypes.string,
    label: PropTypes.string,
    showCount: PropTypes.bool,
});

const JobResultPropType = PropTypes.shape({
    category: PropTypes.string,
    comments: PropTypes.arrayOf(PropTypes.string),
    company: PropTypes.shape({
        id: PropTypes.number,
        url: PropTypes.string,
        name: PropTypes.string,
        jobCount: PropTypes.number,
    }),
    companyLogo: PropTypes.shape({ src: PropTypes.string }),
    contentDate: PropTypes.string,
    daysSinceCreation: PropTypes.number,
    deletable: PropTypes.bool,
    editable: PropTypes.bool,
    hash: PropTypes.string,
    highlight: PropTypes.bool,
    image: PropTypes.shape({ alt: PropTypes.string }),
    isRemote: PropTypes.bool,
    jobPageUrl: PropTypes.string,
    location: PropTypes.string,
    originalApplyUrl: PropTypes.string,
    reactionBar: PropTypes.shape({
        liking: ReactionBarPropType,
        flagging: ReactionBarPropType,
        commenting: ReactionBarPropType,
        sharing: ReactionBarPropType,
    }),
    review: PropTypes.shape({
        url: PropTypes.string,
        count: PropTypes.number,
        rating: PropTypes.string,
    }),
    shortConvincer: PropTypes.string,
    title: PropTypes.string,
    type: PropTypes.string,
    url: PropTypes.string,
    userFlagged: PropTypes.bool,
    userLiked: PropTypes.bool,
});

JobResults.propTypes = {
    results: PropTypes.shape({
        jobs: PropTypes.shape({
            results: PropTypes.arrayOf(JobResultPropType),
            totals: PropTypes.number,
        }),
    }),
    isSingleSearch: PropTypes.bool,
    url: PropTypes.string,
    session: PropTypes.shape({
        id: PropTypes.number,
    }).isRequired,
};

JobResults.defaultProps = {
    results: {
        jobs: {
            results: [],
            total: null,
        },
    },
    isSingleSearch: false,
    url: null,
};
